import React, { useState } from "react";
import { auth } from "../../Config/firebase";
import { sendPasswordResetEmail } from "../../Config/matuAuth";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSending(true);
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setSent(true);
    } catch {
      setError("No se pudo enviar el correo. Revisa que el correo esté registrado.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 px-4">
      <div className="bg-gray-900 p-8 rounded-lg shadow-lg max-w-md w-full border border-gray-800">
        <div className="mb-4 flex justify-center">
          <img src="/Dprologo.png" alt="DeportivosPro" className="h-16 w-16 rounded-full" />
        </div>
        <h2 className="text-3xl font-bold mb-2 text-center text-white">Restablecer contraseña</h2>
        <p className="mb-6 text-center text-sm text-gray-400">
          Te enviamos un correo para que elijas una contraseña nueva.
        </p>

        {error && <p className="text-red-400 text-sm mb-4">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-gray-400">
              Correo electrónico
            </label>
            <input
              type="email"
              id="email"
              className="mt-1 w-full px-4 py-2 bg-gray-800 text-white border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            disabled={sending}
            className="w-full bg-red-500 text-white py-2 rounded-lg hover:bg-orange-600 transition duration-300 disabled:opacity-60"
          >
            {sending ? "Enviando..." : "Enviar enlace"}
          </button>
        </form>

        <div className="mt-4 text-center">
          <a href="/prediccion-zone/start" className="text-orange-500 hover:text-red-500 transition duration-300">
            Volver a iniciar sesión
          </a>
        </div>
      </div>

      {sent && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
          <div className="w-full max-w-sm rounded-2xl bg-white p-6 text-center text-gray-900">
            <img src="/Dprologo.png" alt="" className="mx-auto h-14 w-14 rounded-full" />
            <h3 className="mt-4 text-xl font-extrabold">Correo enviado</h3>
            <p className="mt-2 text-sm leading-6 text-gray-600">
              Revisa {email}. Ahí está el enlace para cambiar tu contraseña.
            </p>
            <a
              href="/prediccion-zone/start"
              className="mt-5 inline-flex rounded-full bg-[#0D5C47] px-5 py-2 text-sm font-bold text-white"
            >
              Volver al inicio de sesión
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default ForgotPassword;
